<template>
  <div id="app">

    <header id="renew2_header">
      <div class="menu_block renew2_wrapper">
        <h1 class="h1">
          <a href="/">
            <img src="/static/renew2_img/logo.png" alt="yagish">
          </a>
        </h1>
        <div class="renew2_pc">
          <ul class="renew2_flex sub_menu">
            <li class="menu_list renew2_link_toggle"><a href="https://www.yagish.jp/company/">運営会社</a></li>
            <li class="menu_list contact renew2_link_toggle"><a href="/contact">お問い合わせ</a>
            </li>
          </ul>
          <ul class="renew2_flex menu">
            <li class="menu_list"><a href="/">履歴書作成_dev</a></li>
            <li class="menu_list"><a href="https://keirekisho.yagish.jp/">職務経歴書作成</a></li>
            <li class="menu_list"><a href="/yagiofferhelp">ヤギオファー</a></li>
            <li class="menu_list" v-if="false"><a href="#">求人一覧</a></li>
            <li v-if="!$firebase.isAuthenticated" class="menu_list login"><a href="/login">ログイン</a></li>
            <li v-if="!$firebase.isAuthenticated" class="menu_list register"><a href="/mregister">会員登録</a></li>
            <li v-if="$firebase.isAuthenticated" class="menu_list renew2_mypage"><a href="/mypage"
                class="on_mypage"><span v-if="$firebase.user.displayName">{{ $firebase.user.displayName }} </span>[ {{
                  $firebase.user.email }} ] <span class="renew2_font_small">さん</span></a></li><!--登録メールアドレス-->
          </ul>
        </div>
        <div class="renew2_sp">
          <ul v-if="!$firebase.isAuthenticated" class="renew2_flex renew2_sp_flex sp_loginbtn">
            <li class="sp_menu_list"><a href="/login">ログイン</a></li>
            <li class="sp_menu_list"><a href="/mregister">会員登録</a></li>
          </ul>
          <div v-if="$firebase.isAuthenticated" class="renew2_mypage"><a href="/mypage" class="on_mypage"><span
                v-if="getName">{{ getName }} </span><span class="renew2_font_small">さん</span></a></div><!--登録メールアドレス-->
        </div>
      </div>
    </header>

    <router-view></router-view>

    <footer id="renew2_footer">
      <div class="renew2_footer">
        <div class="renew2_wrapper footer_block">
          <div class="renew2_flex link_block">
            <div class="link_block__list">
              <img src="/static/renew2_img/logo.svg" alt="ヤギッシュ">
              <p class="renew2_font_small">yagish（ヤギッシュ）は、ブラウザ上で履歴書がつくれる無料サービスです。</p>
              <a href="/contact" class="contact_link renew2_link_toggle">お問い合わせ</a>
            </div><!--ロゴ-->
            <div class="link_block__container renew2_flex">
              <ul class="link_block__list margin">
                <li><a href="/">履歴書作成</a></li>
                <li><a href="https://keirekisho.yagish.jp/">職務経歴書作成</a></li>
                <li><a href="#" v-if="false">求人一覧</a></li>
                <li><a href="/yagiofferhelp">ヤギオファー</a></li>
                <li><a href="/info">yagishの使い方</a></li>
              </ul><!--リンクリスト1-->
              <ul class="link_block__list">
                <li><a href="https://www.yagish.jp/company/">運営会社</a></li>
                <li><a href="/privacy">個人情報保護方針</a></li>
                <li><a href="/terms">利用規約</a></li>
                <li><a href="/help">ヘルプ</a></li>
              </ul><!--リンクリスト2-->
              <!--<ul class="link_block__list">
                          <li><a href="">サイトマップ</a></li>
                      </ul>リンクリスト3-->
            </div>
          </div>
          <div class="service_block">
            <p class="service_block__title">サービス一覧</p>
            <div class="renew2_flex service_block__list">
              <ul class="service_block__item">
                <li><a href="/">履歴書</a></li>
                <li><a href="https://keirekisho.yagish.jp/">職務経歴書作成</a></li>
                <li><a href="#" v-if="false">求人一覧</a></li>
                <li><a href="https://portal.yagish.jp/company/presidents-style/" target="_blank">社長の流儀</a></li>
              </ul><!--リンクリスト1-->
              <ul class="service_block__item">
                <li><a href="/yagiofferhelp">ヤギオファー</a></li>
                <li><a href="/quickmailhelp">ヤギの宅配便</a></li>
                <li><a href="/quickemailhelp">ヤギのメール便</a></li>
                <li><a href="/fontservicehelp">フォントサービス</a></li>
              </ul><!--リンクリスト2-->
              <!--<ul class="service_block__item">
                          <li><a href="">退職代行</a></li>
                          <li><a href="">赤ペン人事部長</a></li>
                      </ul>リンクリスト3-->
            </div>
          </div>
        </div>
        <p class="copyright">©2021-2024 Yagish Co., Ltd. All rights reserved.</p>
      </div>
    </footer>

    <account-dialog />
    <eprint-dialog />
    <cocorowa-dialog />
    <newgrade-dialog />
    <tempdata-dialog />
    <sendmail-dialog />
    <realtime-transfer-appeal-dialog />
    <medley-link-dialog />
    <athlete-dialog />
    <introduction-dialog />
    <all-preview-dialog />
    <yagioffer-dialog />
    <etc-dialog />
    <joblist-dialog />
    <loginform-dialog />
    <fontpayment-dialog />
  </div>
</template>

<style lang="scss" src="@/assets/scss/style.scss"></style>
<style lang="css" src="@/assets/css/renew_reset.css"></style>
<style lang="css" src="@/assets/css/renew_stylesheet.css"></style>
<style lang="css" src="@/assets/css/renew_animation.css"></style>
<style lang="css" src="@/assets/css/renew_tab.css"></style>
<style lang="css" src="@/assets/css/renew_add.css"></style>

<style lang="css" src="@/assets/css/renew2_style.css"></style>
<style lang="css" src="@/assets/css/renew2_login.css"></style>

<script>
import EprintDialog from '@/components/EprintDialog'
import SendMailDialog from '@/components/SendMailDialog'
import CocorowaDialog from '@/components/CocorowaDialog'
import NewGradeDialog from '@/components/NewGradeDialog'
import AccountDialog from '@/components/AccountDialog'
import TempDataDialog from '@/components/TempDataDialog'
import RealtimeTransferAppealDialog from '@/components/RealtimeTransferAppealDialog'
import MedleyLinkDialog from '@/components/MedleyLinkDialog'
import AthleteDialog from '@/components/AthleteDialog'
import IntroductionDialog from '@/components/IntroductionDialog'
import AllPreviewDialog from '@/components/AllPreviewDialog'

import YagiOfferDialog from '@/components/YagiOfferDialog'
import EtcDialog from '@/components/EtcDialog'
import JoblistDialog from '@/components/JobListDialog'
import LoginFormDialog from '@/components/LoginFormDialog'
import FontPaymentDialog from '@/components/FontPaymentDialog'
export default {
  components: {
    'eprint-dialog': EprintDialog,
    'account-dialog': AccountDialog,
    'cocorowa-dialog': CocorowaDialog,
    'newgrade-dialog': NewGradeDialog,
    'tempdata-dialog': TempDataDialog,
    'sendmail-dialog': SendMailDialog,
    'realtime-transfer-appeal-dialog': RealtimeTransferAppealDialog,
    'medley-link-dialog': MedleyLinkDialog,
    'athlete-dialog': AthleteDialog,
    'introduction-dialog': IntroductionDialog,
    'all-preview-dialog': AllPreviewDialog,
    'yagioffer-dialog': YagiOfferDialog,
    'etc-dialog': EtcDialog,
    'joblist-dialog': JoblistDialog,
    'loginform-dialog': LoginFormDialog,
    'fontpayment-dialog': FontPaymentDialog
  },
  data: function () {
    return {
    }
  },
  methods: {
    checkMynabi: function () {
      if (this.$route.query.mynavi === '19xs#rrdfS234') {
        this.$yagi.isFromMynabi = 1
      }
    }
  },
  computed: {
    getName: function () {
      if (this.$firebase.user.displayName) {
        return this.$firebase.user.displayName
      } else {
        return this.$firebase.user.email.split('@')[0]
      }
    },
    logoBaseStyle: function () {
      if (process.env.VUE_APP_MODE === 'production') {
        return {
          fill: '#fff'
        }
      } else if (process.env.VUE_APP_MODE === 'staging') {
        return {
          fill: '#6bff38'
        }
      } else {
        return {
          fill: '#cc38ff'
        }
      }
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    logoEyeStyle: function () {
      if (process.env.VUE_APP_MODE === 'production') {
        return {
          fill: '#e91044'
        }
      } else if (process.env.VUE_APP_MODE === 'staging') {
        return {
          fill: '#09bc6c'
        }
      } else {
        return {
          fill: '#fff'
        }
      }
    },
    isTopPage: function () {
      return (this.$route.name === 'top')
    },
    isMynabi: function () {
      this.checkMynabi()
      return (this.$yagi.isFromMynabi === 1)
    },
    isEditingFormat: function () {
      return (this.$route.name === 'formatEditCard')
    },
    needsFullScreen: function () {
      return (this.$route.name === 'formatPreview')
    },
    needsFooter: function () {
      if (this.$route.name === 'formatPreview' || this.$route.name === 'formatEditCard') {
        return false
      }
      return true
    }
  },
  created: function () {
  }
}
</script>
